import React from 'react';
import {Collapse} from 'antd';
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import {MinusOutlined, PlusOutlined} from "@ant-design/icons";

export default function FaqSkeleton() {
    const customExpandIcon = ({ isActive }) => {
        return isActive ? <MinusOutlined style={{ color: '#F95C59', fontSize: '18px' }}/> : <PlusOutlined style={{ color: '#D2A84E', fontSize: '18px' }} />;
    };
    const { Panel } = Collapse;
    return(

        <div className={'faqs'}>
            <h6 className={'faqs-heading'}>FAQ’s</h6>
            <p className={'sub-head'}>you can submit any query regarding anything to us our rise up king moderator will response you as soon as possible.</p>
            <Collapse accordion expandIconPosition={'end'}  expandIcon={customExpandIcon} >
                {[1,2,3,4,5].map((faq,index) => (
                    <Panel key={index} header={<HeadingSkeleton height={13}/>}>
                        <p><HeadingSkeleton height={10}/></p>
                        <p><HeadingSkeleton height={10}/></p>
                        <p><HeadingSkeleton height={10}/></p>
                        <p><HeadingSkeleton height={10}/></p>
                    </Panel>
                ))}
            </Collapse>;
        </div>
    )
};
